<template>
  <page title="Downloads">
    <div class="box">
      <b-table :data="downloads.data" :loading="downloads.loading" paginated backend-pagination
        pagination-position="bottom" :current-page="downloads.current_page" :per-page="downloads.per_page"
        :total="downloads.total" @page-change="page => downloads.changePage(page)" backend-sorting
        @sort="(field, direction) => downloads.sort(field, direction)" :default-sort="['id', 'desc']" class="is-middle">
        <template slot-scope="props">
          <b-table-column label="User">
            <router-link :to="'/users/' + props.row.user.id" target="_blank">
            {{ props.row.user.id }}: {{ props.row.user.email }} {{ props.row.user.name }}
            </router-link>
          </b-table-column>

          <b-table-column field="issue_id" label="Issue" sortable>
            <span class="has-text-grey">{{ props.row.issue.magazine.name }}</span>
            <span> / </span>
            <span>{{ props.row.issue.title }}</span>
          </b-table-column>

          <b-table-column field="created_at" label="Date" sortable>
            <b-tooltip :label="props.row.created_at">
              {{ props.row.created_at | date }}
            </b-tooltip>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      downloads: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/stats/downloads"
      ).load()
    };
  }
};
</script>
